import { render, staticRenderFns } from "./input-image.vue?vue&type=template&id=adae7894"
import script from "./input-image.vue?vue&type=script&lang=js"
export * from "./input-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports